export type SportScommesseImpostazioni = {
  variazioniQuote: string;
  applyBonusGold: string;
  riduzioneImporto: string;
};

export const ImpostazioniVariazioniQuote = {
  NonAccettareCambioQuota: '0',
  AccettaSoloSeMaggiore: '1',
  AccettaSempre: '3',
} as const;

export const ImpostazioniDiminuzioneImporto = {
  AccettaInAutomatico: '1',
  NonAccettareInAutomatico: '0',
} as const;
